export enum IPostCommentStatus {
  DRAFT = 'DRAFT',
  PUBLIC = 'PUBLIC',
}
